/**
 * Focus on keydown
 */

var keyboardNavigation = false;

const body = document.body;
document.addEventListener('keydown', (e) => {
  if (e.key == 'Tab') {
    body.classList.add('is-keyboard-pressed')
    keyboardNavigation = true;
  }
});

['click', 'mousedown'].forEach(event => document.addEventListener(event, (e) => {
  const target = e.target
  if (target.matches('input[type=radio], input[type=checkbox], button[type="button"], a[href="#"]')) {
    if (keyboardNavigation == false) {
      body.classList.remove('is-keyboard-pressed')
      keyboardNavigation = false;
    }
  } else {
    body.classList.remove('is-keyboard-pressed')
    keyboardNavigation = false;
  }
}))

const elements = document.querySelectorAll('input[type=radio], input[type=checkbox], button[type="button"], a[href="#"]')

elements.forEach(element => element.addEventListener('keydown', ()=>{
  body.classList.add('is-keyboard-pressed')
      keyboardNavigation = true;
}))
